import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SearchResultApiModel } from '@app/api/api-models/search/SearchResultApiModel';
import { RouteHelperService } from '../../services/route-helper.service';

@Component({
  templateUrl: './reject-summaries-modal.component.html',
  styleUrls: ['./reject-summaries-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RejectSummariesModalComponent implements OnInit {
  @Input()
  public mode: string;
  @Input()
  public confirm: Function;
  @Input()
  public cancel: Function;
  @Input()
  public summaryFormInstances: Array<SearchResultApiModel>;

  @HostBinding('class')
  public modalType = 'lg';

  public actionButtonText: string;
  public actionProcess: string;
  public actionText: string;

  constructor(private readonly bsModalRef: BsModalRef, private readonly routeHelper: RouteHelperService) {}

  public ngOnInit(): void {
    if (this.mode === 'reject') {
      this.actionButtonText = 'Yes, Reject';
      this.actionProcess = 'rejecting';
      this.actionText = 'reject';
    }

    if (this.mode === 'delete') {
      this.actionButtonText = 'Yes, Delete';
      this.actionProcess = 'deleting';
      this.actionText = 'delete';
    }
  }

  public close(): void {
    if (this.cancel) {
      this.cancel();
    }
    this.bsModalRef.hide();
  }

  public openFormInstance(id: number): void {
    this.routeHelper.formInstance(id).then(() => this.routeHelper.reload(this.routeHelper.getCurrentUrl()));

    this.close();
  }

  public onConfirm(): void {
    if (this.confirm && typeof this.confirm === 'function') {
      this.confirm();
    }

    this.close();
  }
}
